import React from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  makeStyles
} from "@material-ui/core";
import { isEmpty, truncate } from "lodash";
import { useIntl } from "react-intl";

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(1)
  },
  cardMedia: {
    height: "15rem",
    backgroundColor: "white",
    objectFit: "contain"
  },
  cardContent: {
    height: "15rem",
    padding: theme.spacing(3)
  },
  success: {
    color: "green"
  }
}));

const CardItemWithActions = ({
  coverImageUrl,
  thumbUrl,
  title,
  description,
  onClick,
  actions,
  truncateWords = false,
  fileName
}) => {
  const classes = useStyles();
  const intl = useIntl();

  // Assign preview url
  const previewUrl = coverImageUrl || thumbUrl;

  return (
    <>
      <Card elevation={0} className={classes.card}>
        <CardActionArea onClick={onClick} disabled={!onClick}>
          {previewUrl ? (
            <CardMedia
              component="img"
              image={previewUrl}
              alt={title}
              title={title}
              className={classes.cardMedia}
            />
          ) : (
            <CardContent className={classes.cardContent}>
              {fileName && (
                <Typography className={classes.success}>
                  <strong>
                    {intl.formatMessage({
                      id: "Shared.CardItemWithActions.Uploaded",
                      defaultMessage: "Uploaded"
                    })}
                  </strong>
                </Typography>
              )}
              {fileName}
            </CardContent>
          )}
        </CardActionArea>
        {!isEmpty(actions) && (
          <CardActions>
            {actions.map(({ label, action }) => (
              <Button color="primary" onClick={action}>
                {label}
              </Button>
            ))}
          </CardActions>
        )}
      </Card>
      <Typography variant="body1">
        <strong>{truncateWords ? truncate(title, { length: 40 }) : title}</strong>
      </Typography>
      <Typography variant="body2">
        {truncateWords ? truncate(description, { length: 80 }) : description}
      </Typography>
    </>
  );
};

export default CardItemWithActions;
